import { cn } from '@/lib/utils';

/** A shaped placeholder; give it the size of what will load. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('skeleton', className)} aria-hidden="true" />;
}

/** A stack of placeholder lines, for lists and forms. */
export function SkeletonLines({ count = 3, className, lineClassName = 'h-10' }: { count?: number; className?: string; lineClassName?: string }) {
  return (
    <div className={cn('space-y-2', className)} aria-hidden="true">
      {Array.from({ length: count }, (_, i) => <div key={i} className={cn('skeleton', lineClassName)} />)}
    </div>
  );
}

/** Placeholder for a whole page while its first data loads: a header, a row of tiles and a panel. */
export function PageSkeleton({ tiles = 0 }: { tiles?: number }) {
  return (
    <div className="space-y-6" aria-hidden="true" data-testid="page-skeleton">
      <div><div className="skeleton h-8 w-48" /><div className="skeleton mt-2 h-4 w-72 max-w-full" /></div>
      {tiles > 0 && (
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {Array.from({ length: tiles }, (_, i) => <div key={i} className="skeleton h-28 rounded-2xl" />)}
        </div>
      )}
      <div className="skeleton h-72 rounded-2xl" />
    </div>
  );
}
